import React from 'react';
export function SubscriberEditIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.824 2.263a1.005 1.005 0 011.386.033l2.493 2.493c.406.406.39 1.069-.034 1.454l-5.495 4.996c-.143.13-.32.216-.511.248l-2.992.498a1.005 1.005 0 01-1.156-1.156l.498-2.992c.037-.223.149-.426.316-.578l5.495-4.996zm.643 2.118L13.93 8.507l-.212 1.276 1.328-.221 4.506-4.096-1.084-1.085z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 7.023C4 4.244 6.268 2 9.037 2c1.782 0 2.94.452 3.83 2.002a1 1 0 01-1.734.996C10.602 4.073 10.108 4 9.037 4A3.035 3.035 0 006 7.023v1.699c0 1.19.49 2.216 1.375 2.794l.166.108c.378.243.459.376.459.876v.5a1 1 0 01-1 1c-1.531 0-3 1.132-3 3v2a1 1 0 001 1h9v-3c0-1.346-.228-1.665-1.019-2.145a1 1 0 111.038-1.71c1.209.734 1.98 1.623 1.98 3.855v3c0 1-.89 2-1.5 2H3.552C3.5 22 2 21.5 2 20L2 17c0-2.39 1.473-4.043 3.268-4.693C4.408 11.312 4 10.017 4 8.722v-1.7z"
  }));
}